import { Injectable } from '@angular/core';
import { baseUrl } from './url';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class CareerService {
  constructor(private http: HttpClient) {}

  careerApply(api, doctype): Observable<any> {
    return this.http.post<any>(baseUrl + "docs.php/" + api, doctype);
  }
}
